import React from 'react';
import { TransactionStatus } from '../../../store/actions/depositFileActions';
import { LYXERSCAN_URL } from '../../../utils/envVars';
import {
  TagIndicator,
  TagColors,
  YellowTag,
  RedTag,
  GreenTag,
} from '../../../components/TagIndicator';
import styled from 'styled-components';

interface Props {
  transactionStatus: TransactionStatus;
  txHash: string | undefined;
}

const Link = styled.a`
  text-decoration: none;
`;

export const TxStatus: React.FC<Props> = ({ transactionStatus, txHash }) => {
  let text = '';
  let colors: TagColors = { foreground: '', background: '' };
  switch (transactionStatus) {
    case TransactionStatus.READY:
      text = '-';
      break;

    case TransactionStatus.PENDING:
      text = 'Pending';
      colors = YellowTag;
      break;

    case TransactionStatus.FAILED:
      text = 'Failed';
      colors = RedTag;
      break;

    case TransactionStatus.REJECTED:
      text = 'Rejected';
      colors = RedTag;
      break;

    case TransactionStatus.SUCCEEDED:
      text = 'Success';
      colors = GreenTag;
      break;

    default:
      break;
  }

  return txHash ? (
    <Link target="_blank" href={`${LYXERSCAN_URL}/tx/${txHash}`}>
      <TagIndicator value={text} colors={colors} />
    </Link>
  ) : (
    <TagIndicator value={text} colors={colors} />
  );
};
